import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter7 extends Component {
  static displayName = Chapter7.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—7: घर-त्याग, गुरु-दर्शन और दिव्य वन-तप 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                वर्षों से भीतर सुलग रही आध्यात्मिक ज्वाला अब अपने पूर्ण आकार में प्रकट होने लगी थी। बाबा ब्रह्म नारायण (आगे चलकर गुरुदेव) दिन-प्रतिदिन संसार से विरक्त होते जा रहे थे।<br/><br/>
                माता-पिता अनेक बार समझाते— “तुम अभी छोटे हो, पढ़ो-लिखो, जीवन को समझो।” पर इस बालक का मन किसी अदृश्य दिशा में खिंच चुका था— वह दिशा थी सन्यास, त्याग, तप और गुरु-मार्ग की।
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>घर छोड़ने की पूर्व-रात्रि — मौन की वेदना</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              एक रात, चंद्रमा की मद्धिम रोशनी आँगन में बिखरी हुई थी। माता जी दरवाज़े पर सोई थीं, पर ब्रह्म नारायण की आँखों में नींद नहीं थी। वे चुपचाप आँगन में बैठे आकाश की ओर देख रहे थे— मानो ऊपर किसी से संवाद कर रहे हों।
              धीरे से उठे, माता जी के चरणों में प्रणाम किया, और मन ही मन कहा— “सरकार, क्षमा कीजिएगा। मेरा मार्ग अब घर की सीमा से बाहर है।” वह क्षण केवल विदाई नहीं था— वह एक आत्म-समर्पण था। एक जीवन का अंत, और दूसरे जीवन का आरंभ।
            </p>

            {/* More Sections */}
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>पहली यात्रा — अज्ञात की ओर कदम</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              ब्रह्म नारायण बिना किसी सामान के, नंगे पैर, सिर्फ एक लाठी सहारे पोखवां से बाहर निकल पड़े। रास्ता लंबा था, अकेलापन भी। पर भीतर एक उत्साह था, जैसे कोई दैवी शक्ति हर कदम पर उन्हें आगे बढ़ा रही हो। चलते-चलते वे वनखंडी के पास एक आश्रम पहुँचे— जहाँ उनके जीवन का सबसे बड़ा वरदान मिलने वाला था।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>गुरु से प्रथम दर्शन — अद्वैतानंद जी की दृष्टि</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी अद्वैतानंद सरस्वती जी उसी दिन आश्रम के बाहर ध्यानावस्था में विराजमान थे। ब्रह्म नारायण ने उन्हें देखते ही एक क्षण के लिए रुक कर गहरी साँस ली। ऐसा लग रहा था जैसे वे इसी क्षण की प्रतीक्षा में जन्मे हों। स्वामी जी ने आँखें खोलीं, और बालक को देखकर मुस्कराए। उन्होंने कहा— “तो तुम आ ही गए… जिसे भेजा गया था, वह अपने आप पहुँचता है। आओ, तुम्हारा स्थान यहीं है।” इन शब्दों ने बालक के मन की समस्त उलझनें समाप्त कर दीं। उनका हृदय पहली बार पूर्ण विश्राम में डूब गया। यह केवल गुरुदर्शन नहीं था— यह गुरु-शिष्य संबंध का जन्म था। ऐसा संबंध जो कोई पुस्तक, कोई साधना, कोई तप— अपने आप नहीं बना पाते। यह दैवी अनुग्रह से ही होता है।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>वन-तप का आरंभ — जहाँ से महापुरुष गढ़े जाते हैं</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरु के सान्निध्य में ब्रह्म नारायण का जीवन पूरी तरह बदल गया।

🌿 तप का पहला पाठ

स्वामी अद्वैतानंद जी ने कहा—

“तप गुफाओं में नहीं, अपने भीतर किया जाता है। बाहरी कष्ट तो केवल औजार हैं।”

ब्रह्म नारायण ने पहले दिन ही निर्भीक भाव से कठोर नियम अपना लिए— भोर में ब्रह्ममुहूर्त उठना, नित्य मौन साधना, न्यूनतम भोजन, नदी पर जलाधार, रात्रि में एकांत ध्यान और इन सबके साथ गहन आत्म-स्वाध्याय।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌳 वन का एकांत — आत्मा की प्रयोगशाला</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              घने जंगल, अकेलापन, गूँजता हुआ मौन— इन सबके बीच बालक तेजी से परिवर्तित होता जा रहा था। लोगों ने कई बार देखा कि वह रात में अकेले गहरे जंगल में घूमता— कभी ध्यानस्थ, कभी मौन, कभी समाधि जैसी अवस्था में। एक साधु ने कहा— “यह बालक जन्मजात योगी है। इसकी आत्मा साधारण की नहीं।”
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>माँ बगलामुखी की दीक्षा — वाणी में अद्भुत तेज</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी अद्वैतानंद जी स्वयं माँ बगलामुखी के उपासक थे। उन्होंने बालक की पात्रता देखकर उन्हें बगला-मंत्र-दीक्षा दी। यह दीक्षा सामान्य नहीं— अत्यंत गूढ़, अत्यंत शक्तिशाली, और अत्यंत अनुशासन वाले साधकों को ही दी जाती है। इसके बाद ब्रह्म नारायण की वाणी में अद्भुत तेज आ गया। किसी को समझाते, तो हिंसक भी शांत हो जाता। किसी को दुविधा होती, तो उनके केवल एक वाक्य से उसका मन निर्मल हो जाता। यह वही शक्ति थी जिसके बल पर आगे चलकर उन्होंने समाज में असंख्य संघर्षों को बिना हथियार के शांत किया।
            </p>

            
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>गुरु की घोषणा — “यह बालक धर्मराज बनेगा”</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              एक दिन वन के गहन एकांत में गुरु और शिष्य दोनों मौन बैठे थे। अचानक स्वामी अद्वैतानंद जी बोले— “ब्रह्म नारायण… तुम्हारे भीतर जो तेज है, वह दुर्लभ है। तुम या तो धर्मराज बनोगे या यति-राज। और मुझे लगता है— तुम्हारा मार्ग यति का है।” यह वह क्षण था जब गुरु ने शिष्य के भविष्य पर अपनी मुहर लगा दी। और यह भविष्यवाणी बाद में अक्षरशः सत्य हुई— ब्रह्म नारायण वही बने जिन्हें विश्व जानता है गुरुदेव स्वामी ब्रह्मानंद सरस्वती जी महाराज के नाम से।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>अध्याय का सार</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              इस अध्याय में हमने देखा— बालक का घर त्याग, गुरु से प्रथम मिलन, वन-तपस्या का आरंभ, माँ बगलामुखी की गूढ़ साधना और गुरु की भविष्यवाणी
              <br/><br/>
              यह अध्याय बताता है कि महापुरुष बनने का मार्ग एकांत, त्याग, साहस और दिव्यता से होकर गुजरता है।
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter5" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter8" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}